import { gtag, install } from "ga-gtag";
import { PublicVariables, GLOBAL_MEETING_DATA, CALL_DATA } from "../constants/PublicVariables";
import { EVENT_NAME, EXTRA_PARAM_NAME, EXTRA_PARAM_TYPE } from "../constants/GTagConstants";
import { FilterObjectByArrayOfKeys } from "../shared/function";

const TRACKING_CODE = process.env.REACT_APP_GOOGLE_TAG;

class GoogleEvents {
    isInitialized = false;

    initializeGoogleTagManager(logEventCallback = null) {
        if (!this.isInitialized) {
            install(TRACKING_CODE);
            /* set variable to true to avoid reinstallation of gTag */
            this.isInitialized = true;
            /* Log below events as soon as gTag install */
            gtag("js", new Date());
            gtag("config", TRACKING_CODE);
            this.logEvent(EVENT_NAME.LAUNCHED_SHOWME, EXTRA_PARAM_NAME.EVENT_SOURCE, "PAGE_LOAD");
        }

        if (logEventCallback) {
            logEventCallback();
        }
    }

    logEvent(eventName, extraParamName, extraParamValue) {
        if (!PublicVariables.ldFlags?.captureDeviceAndGoogleEvent) {
            return;
        }

        if (!this.isInitialized) {
            //If not initialized than Initialize first
            this.initializeGoogleTagManager(() => {
                this.logEvent(eventName, extraParamName, extraParamValue);
            });

            return;
        }

        //log event
        let eventObj = {};

        if (extraParamName === EXTRA_PARAM_TYPE.obj) {
            eventObj = JSON.parse(JSON.stringify(extraParamValue));
        }

        const propertiesToRemove = [
            EXTRA_PARAM_NAME.ENTERED_NUMBER_OF_DIGITS,
            EXTRA_PARAM_NAME.EVENT_SOURCE,
            EXTRA_PARAM_NAME.SELECTED_LANGUAGE,
            EXTRA_PARAM_NAME.ZOOM_VALUE,
        ];

        eventObj = FilterObjectByArrayOfKeys(eventObj, propertiesToRemove);

        const eventsToAdd = [EVENT_NAME.LANGUAGE, EVENT_NAME.ZOOM_BY_AGENT, EVENT_NAME.CONNECT_TAPPED, EVENT_NAME.LAUNCHED_SHOWME];

        eventsToAdd.forEach((value, _index) => {
            if (eventName === value) {
                eventObj[extraParamName] = extraParamValue;
            }
        });

        eventObj.REFERENCE_TEXT = CALL_DATA.referenceId || "";
        eventObj.COMPANY_NAME = GLOBAL_MEETING_DATA.domainName || "";
        eventObj.MEMBER_ID = CALL_DATA.memberId ? CALL_DATA.memberId.toString() : "";
        eventObj.MEETING_ID = GLOBAL_MEETING_DATA.sessionId || "";
        eventObj.ROLE = GLOBAL_MEETING_DATA.survey.inSurveyAgentOrGuestName || "";
        eventObj.CID = GLOBAL_MEETING_DATA.cid || "";
        eventObj.UCID = GLOBAL_MEETING_DATA.ucid || "";

        console.log("event", eventName, eventObj);
        gtag("event", eventName, eventObj);
    }
}

export default new GoogleEvents();
